<template>
  <div>

    <label>UsernameTarget</label>
    <input v-model="UsernameTarget"></input>
    <label>Password</label>
    <input v-model="passwordAdmin"></input>
    <button @click="getUserAll"> Submit</button>
    <button @click="GotoDW"> Proceed to the dashboard user</button>
    <b-form-select v-model="selected" :options="optionsChoose"></b-form-select>
    <router-link :to="{name:'Profile'}">Go to Overview</router-link>
  </div>

</template>

<script>
    import {refreshIdToken} from '../util/utilsYsy'

    export default {
        name: 'AdministratorYsy',
        data() {
            return {
                passwordAdmin: '',
                selected: '',
                UsernameTarget: '',
                allUsers: '',
                optionsChoose: [
                    {value: null, text: 'Please select an option'},
                ]

            }
        },
        components: {},
        methods: {
            GotoDW() {
                localStorage.removeItem('dict_response_dashboard');
                const dict_token = this.allUsers[this.selected];
                // console.log(dict_token);

                if ("error" in dict_token) {
                    this.$router.push({name: 'Landing'});
                    return
                }
                const payload = {
                    "user": dict_token['cognito:username'],
                    "emailLinkedin": 'custom:email_linkedin' in dict_token ? dict_token['custom:email_linkedin'] : 'NaN',
                    "role": 'custom:role' in dict_token ? dict_token['custom:role'] : 'user',
                    "lastWithdrawRun": 'custom:lastWithdrawRun' in dict_token ? dict_token['custom:lastWithdrawRun'] : '1549580400',
                    "haveAccount": 'custom:haveAccount' in dict_token ? (dict_token['custom:haveAccount'] === 'true') : false,
                    "isBlocked": 'custom:isBlocked' in dict_token ? (dict_token['custom:isBlocked'] === 'true') : true,
                    "referrer": 'custom:referrer' in dict_token ? dict_token['custom:referrer'] : 'YSY',
                    "automatedYsyActions": 'custom:automatedYsyActions' in dict_token ? dict_token['custom:automatedYsyActions'].split('@YSY@') : [],
                    "notificationActionYsy": 'custom:notifyYsyActions' in dict_token ? dict_token['custom:notifyYsyActions'].split('@YSY@') : [],
                    "emailInstagram": 'custom:email_instagram' in dict_token ? dict_token['custom:email_instagram'].split(',') : [],
                    "haveAccountInstagram": 'custom:haveAccountInstagram' in dict_token ? (dict_token['custom:haveAccountInstagram'] === 'true') : false,
                };
                console.log(payload);
                this.$store.commit('auth_success', payload);
                if (dict_token['cognito:username'] === 'branchofapp') {
                    this.$router.push({name: 'adminysy'});
                    return
                }
                if (dict_token['custom:isBlocked'] === 'true') {
                    this.$router.push({name: 'Profile'})
                } else {
                    this.$router.push({name: 'Dashboard'})
                }
            },
            refreshIdToken,
            async getUserAll() {
                let payload;
                if (this.UsernameTarget !== '') {
                    payload = {
                        password: this.passwordAdmin,
                        UsernameTarget: this.UsernameTarget,
                        type: "target"
                    };

                } else {
                    payload = {
                        password: this.passwordAdmin,
                        type: "active"
                    };
                }
                const headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                const path = `${this.BACKEND_YSY}/admin-ysy`;

                this.$http
                    .post(path, payload, {headers}).then(res => {
                        var self = this;
                        this.allUsers = res.data;
                        Object.keys(res.data).forEach(function (key) {
                            console.log(key, res.data[key]);
                            self.optionsChoose.push({value: key, text: key})
                        });
                    }
                ).catch(error => {
                    // eslint-disable-next-line
                    console.error("axios error", error);
                });

                console.log('End of Successful Run')

            }
        }
    };
</script>
